<template>
  <div class="public-navbar">
    <v-toolbar
      v-resize="onResize"
      dark
      fixed
      app
      clipped-left
      :color="dark ? 'active-menu' : 'black'"
      :class="
        user != null && showPanelInv != false
          ? { [`pt-${isMobile ? 0 : 0}`]: true }
          : { [`pt-${isMobile ? 0 : 0}`]: true }
      "
    >
      <router-link to="/">
        <img
          alt="RedCapital logo"
          :src="`${RedCapital[SelectedCountry].Logo}`"
          class="rclogo"
          style="padding-right: 20px"
        />
      </router-link>
      <img
        v-if="user != null && showPanelInv != false"
        alt="RedCapital logo"
        :src="urlimag"
        class="invlogo"
      />

    </v-toolbar>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";
import {formatCurrency} from "@/utils"
import API from '@/api';

@Component({
  data() {
    return {
      SelectedCountry,
      RedCapital,
      dark: true,
      canShowUserMenu: false,
      showMenu: false,
      showMenuTutorial: false,
      classMenuTutorial: '',
      isMobile: true,
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth <= 960) {
        this.$data.isMobile = true;
      } else {
        this.$data.isMobile = false;
        this.$data.showMenu = false;
      }
    },
    login() {
      this.$data.showMenu = false;
      this.$data.canShowUserMenu = false;
      this.$data.showMenuTutorial = false;
      EventBus.$emit("open-login-dialog");
    },
    logout() {
      EventBus.$emit("logout");
    }
  }
})
export default class NavBar extends Vue {}
</script>

<style lang="scss" scoped>
.rc-navEmpresa {
  border: 1.5px solid #ffffff;
  border-radius: 500px;
  color: #ffffff;
  font-family: SF Pro Text;
  font-style: normal;
  font-weight: 600;
  background-color: transparent;

  /* identical to box height */
}
.font-OneRem {
  font-size: 1rem !important;
}
.navbar {
  z-index: 3;
}
.rclogo {
  @media (max-width: 960px) {
    height: 40px;
  }
  @media (min-width: 960px) {
    height: 50px;
  }
}
.invlogo {
  @media (max-width: 960px) {
    height: 20px;
  }
  @media (min-width: 960px) {
    height: 25px;
  }
}
.dis-none {
  @media (max-width: 600px) {
    display: none;
  }
}
.v-menu__content {
  position: fixed !important;
  border-radius: 1rem !important;
}
.active {
  box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.btnsitio {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}

// MENUS Sito Solicitante e Inversionista
/*.rc-listCerrarSesion{
		position: absolute;
		bottom: 0;
		width: 284px;
		margin-bottom: 30px;
		a{
			div{
				i{
					color: $rc-prim-n1 !important;
				}
				div
				{
					color: $rc-prim-n1 !important;
					font-weight: 600;
				}
			}
		}
	}*/
.rc-menuDrawerSitios {
  margin-top: 64px !important;
  z-index: 1;
  width: 150px !important;
  height: calc(100vh - 64px) !important;
  min-height: 100%;
}
.rc-listItem-title {
  font-weight: 600;
  //color: $rc-prim-g2 !important;
}
.rc_notificacion {
		height: 14px; 
		width: 14px;
		position: absolute; 
		right: 0px; 
		top: 5px; 
		background-color: red; 
		border-radius: 50%;
	}
// Breakpoints
@each $breakpoint in $breakpoints_screen_text {
  @include breakpoint_media_queries($breakpoint) {
    @if $breakpoint == "x-large" {
    } @else if $breakpoint == "large" {
    } @else if $breakpoint == "medium-to-large" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    } @else if $breakpoint == "small-to-medium" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    } @else if $breakpoint == "small" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    }
  }
}
</style>
